
import { Vue, Component, Ref } from 'vue-property-decorator';
import Representative from './components/Representative.vue';
import Foundation from './components/Foundation.vue';
import QuickEntrance from './components/QuickEntrance.vue';
import Individual from './components/Individual.vue';
import StatisticsMod from './components/StatisticsMod.vue';
import Loading from '@/components/loading/index.vue';
import Watermark from '@/components/watermark/index.vue';
import UserService from '@/services/user.service';
import lazyInject from '@/di';
import WorkbenchesService from '@/services/workbenches.service';

@Component({
  components: {
    Representative,
    Foundation,
    QuickEntrance,
    Individual,
    Loading,
    StatisticsMod,
    Watermark,
  },
})
export default class Workbenches extends Vue {
  @Ref('quickEntrance')
  quickEntrance!: QuickEntrance;

  @Ref('representative')
  representative!: Representative;

  @Ref('statisticsMod')
  statisticsMod!: StatisticsMod;

  @Ref('individual')
  individual!: Individual;

  @lazyInject(WorkbenchesService)
  workbenchesService!: WorkbenchesService;

  @lazyInject(UserService)
  user!: UserService;

  // text = `${this.user.currentUser()?.name} ${this.user.currentUser()?.phone?.substring(0, 3)}****${this.user.currentUser()?.phone?.substring(7)}`;
  text = '';

  userModule: any = {
    myTodo: [],
    myAchievement: [],
    dashboard: [],
    quickEntrance: [],
  };

  type: any = '';
  position: any = {
    assistantDirector: '总监助理',
    kaTeamLeader: '大B组长',
    kaTeamMinister: '大B部长',
    ordinaryTeamLeader: '小B组长',
    ordinaryTeamMinister: '小B部长',
    director: '总监',
  };

  changeType(type: any) {
    this.type = type;
  }
  mounted() {
    this.getUserModule();
  }
  async getUserModule() {
    const res = await this.workbenchesService.getUserModule();
    if (res) {
      const { myTodo, myAchievement, dashboard, quickEntrance } = res;
      if (myTodo) {
        this.userModule.myTodo = myTodo;
      }
      if (myAchievement) {
        this.userModule.myAchievement = myAchievement;
      }
      if (dashboard) {
        this.userModule.dashboard = dashboard;
      }
      if (quickEntrance) {
        this.userModule.quickEntrance = quickEntrance;
      }
      this.$nextTick(() => {
        if (this.userModule.quickEntrance.length > 0) {
          this.quickEntrance.closeLading();
        }
        if (this.userModule.myTodo.length > 0) {
          this.representative.init();
        } else {
          this.representative.clase();
        }

        if (this.userModule.dashboard.length > 0) {
          this.statisticsMod.init(this.type);
        }
        if (this.userModule.myAchievement.length > 0) {
          this.individual.getMyList();
        }
      });
    }
  }
}
